import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { rejectExitRequest } from 'services/fund/settlement'

/**
 * رد کردن درخواست — the member stays in the fund and nothing financial moves.
 *
 * The toast used to read «کاربر با موفقیت حذف شد», which describes the
 * opposite outcome: rejecting a request is precisely the case where the
 * member is NOT removed.
 */
export default function useRejectSettlement(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: getAdminSettlementsPostPayload) => {
            return rejectExitRequest(payload)
        },
        onSuccess: (_, variables) => {
            posthog.capture('exit_request_rejected', {
                moneypool_id: variables.moneyPool,
            })
            toast.success('درخواست رد شد.')
            refetch()
        },
        onError: (error: any, variables) => {
            posthog.capture('exit_request_reject_failed', {
                moneypool_id: variables.moneyPool,
                status: error?.response?.status,
            })
            toast.error('رد درخواست انجام نشد؛ دوباره تلاش کنید.')
        },
    })
    return { isRejecting: isLoading, reject: mutate }
}
